import * as React from "react";
import Text from "../components/Entities/Text";
import Title from "../components/Entities/Title";
import RatingStars from "./Entities/RatingStars";
import Icon from "./Entities/Icon";
import Logo from "./Icons/Logo";

/**
 * Represents the props for the Review component.
 */
interface ReviewValueProps {
  title: string;
  comment: string;
  author: string;
  rating: number;
  isAdmin?: boolean;
}

/**
 * Represents the props for the Reviews component.
 */
interface ReviewProps {
  review: ReviewValueProps;
}
const Review: React.FC<ReviewProps> = (props) => {
  const { review } = props;

  /**
   *
   * @param review
   * @param index
   * @returns
   */

  const { title, comment, author, rating, isAdmin = false } = review;
  return (
    <div className="bg-primary rounded max-w-md w-[100%] mx-auto p-4 my-4">
      <Title
        value={{
          children: title,
          type: "h3",
          className: "text-white open-sans-normal",
        }}
      />
      <RatingStars
        value={{
          onChange: null,
          selectedValue: rating,
          className: " text-left  my-2",
          fillColor: "#fff",
          emptyColor: "#fff",
          fontSize: "1.3rem",
        }}
      />
      <Text
        value={{
          injectedChildren: comment,
          className: "text-secondary text-sm open-sans-normal",
        }}
      />
      <Text
        value={{
          injectedChildren: "",
          className: "text-white text-sm open-sans-light pb-4 flex items-center mt-2",
        }}
      >
        {isAdmin ?  <Logo props={{ className: "h-[20px] pr-2", fill: "#fff" }} /> : null}
        {author}{" "}
        {isAdmin ? <span className="text-[#aaa] pl-2">• Staff Member</span> : null}
      </Text>
    </div>
  );
};

export default Review;
